import React from "react";

export const ArrowSvg = ({ color, width, height }) => (
  <svg height={height} width={width} viewBox="0 0 138.3311 99.409599">
    <g id="layer1" transform="translate(-45.508182,-96.555181)">
      <path
        id="path815"
        style={{
          fill: "none",
          fillOpacity: "1",
          fillRule: "evenodd",
          stroke: color || "#000000",
          strokeWidth: "6.86499977",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          strokeOpacity: "1",
        }}
        d="M 48.989554,146.25998 H 172.46938"
      />
      <path
        id="path817"
        style={{
          fill: "none",
          fillOpacity: "1",
          fillRule: "evenodd",
          stroke: color || "#000000",
          strokeWidth: "6.86499977",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: "4",
          strokeDasharray: "none",
          strokeOpacity: "1",
        }}
        d="m 134.1693,100.02235 46.23763,46.23763 -46.23763,46.23763"
      />
    </g>
  </svg>
);
